import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ExportCustomer from "./ExportCustomer";
import ExportWorkOrder from "./ExportWorkOrder";
import API from "services/axios";
import authHeader from "services/auth-header";
import { setNotification } from "features/Notification/notificationSlice";
import { useDispatch } from "react-redux";
import Spinner from "components/Spinner";

export default function ExportsLayout() {
  const [searchParams, setSearchParams] = useSearchParams();

  /*   All States
   ********************************************* */
  const [selectedTab, setSelectedTab] = useState("customers");

  /*   All Functions
   ********************************************* */
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [locationsList, setLocationsList] = useState(null);

  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };

  const updateSearchParams = (key, value) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);

      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }

      return newParams.toString();
    });
  };

  const getLocations = async () => {
    try {
      loadingOn();
      const { data } = await API.get("/locations", { headers: authHeader() });
      setLocationsList(data);
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    let filterBy = searchParams.get("export-type");
    if (filterBy) {
      setSelectedTab(filterBy);
    } else {
      setSelectedTab(null);
      updateSearchParams("export-type", "customers");
    }
  }, [searchParams]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      getLocations();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div>
      {loading && <Spinner />}
      {/* Tabs */}
      <div className="">
        <button
          className={`btn ${
            selectedTab === "customers" ? "btn-primary" : "bg-white"
          }`}
          onClick={(e) => {
            updateSearchParams("export-type", "customers");
          }}
        >
          Customers
        </button>

        <button
          className={`btn ${
            selectedTab === "work-order" ? "btn-primary" : "bg-white"
          }`}
          onClick={(e) => {
            updateSearchParams("export-type", "work-order");
          }}
        >
          Work Order
        </button>
      </div>
      {/* Content */}
      {locationsList && (
        <div className="">
          {selectedTab === "customers" && (
            <ExportCustomer locationsList={locationsList} />
          )}
          {selectedTab === "work-order" && (
            <ExportWorkOrder locationsList={locationsList} />
          )}
        </div>
      )}
    </div>
  );
}
